import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? "text-yellow-500" : "text-gray-300 hover:text-yellow-500";
  };

  return (
    <nav className="fixed w-full z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex-shrink-0">
            <Link to="/" className="flex flex-col group">
              <span className="text-3xl font-black tracking-tighter text-white group-hover:text-gray-200 transition-colors">
                ŞAHİN <span className="text-yellow-500">VIP</span>
              </span>
              <span className="text-[10px] tracking-[0.4em] text-gray-400 uppercase group-hover:text-yellow-500/70 transition-colors">
                Transfer Hizmetleri
              </span>
            </Link>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link to="/" className={`${isActive('/')} px-3 py-2 rounded-md text-sm font-bold transition-all duration-300 hover:scale-105`}>ANA SAYFA</Link>
              <Link to="/filo" className={`${isActive('/filo')} px-3 py-2 rounded-md text-sm font-bold transition-all duration-300 hover:scale-105`}>FİLOMUZ</Link>
              <Link to="/fiyatlar" className={`${isActive('/fiyatlar')} px-3 py-2 rounded-md text-sm font-bold transition-all duration-300 hover:scale-105`}>FİYAT LİSTESİ</Link>
              <Link to="/iletisim" className={`${isActive('/iletisim')} px-3 py-2 rounded-md text-sm font-bold transition-all duration-300 hover:scale-105`}>İLETİŞİM</Link>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-4">
             <a href="https://wa.me/905468953037" target="_blank" rel="noopener noreferrer">
                <Button className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white gap-2 font-bold shadow-lg shadow-green-900/20 border-0">
                    <Phone className="h-4 w-4" />
                    0546 895 30 37
                </Button>
             </a>
          </div>
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-white/10 focus:outline-none"
            >
              {isOpen ? <X className="h-8 w-8 text-yellow-500" /> : <Menu className="h-8 w-8 text-white" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-b border-white/10 absolute w-full h-screen">
          <div className="px-4 pt-8 pb-3 space-y-4 flex flex-col items-center justify-center h-[60vh]">
            <Link to="/" onClick={() => setIsOpen(false)} className="text-white hover:text-yellow-500 block px-3 py-4 rounded-md text-2xl font-bold">ANA SAYFA</Link>
            <Link to="/filo" onClick={() => setIsOpen(false)} className="text-white hover:text-yellow-500 block px-3 py-4 rounded-md text-2xl font-bold">FİLOMUZ</Link>
            <Link to="/fiyatlar" onClick={() => setIsOpen(false)} className="text-white hover:text-yellow-500 block px-3 py-4 rounded-md text-2xl font-bold">FİYAT LİSTESİ</Link>
            <Link to="/iletisim" onClick={() => setIsOpen(false)} className="text-white hover:text-yellow-500 block px-3 py-4 rounded-md text-2xl font-bold">İLETİŞİM</Link>
            
            <div className="pt-8 w-full max-w-xs">
                <a href="https://wa.me/905468953037" target="_blank" rel="noopener noreferrer" className="block w-full">
                    <Button className="w-full h-14 text-lg bg-green-600 hover:bg-green-700 text-white gap-2 rounded-full">
                        <Phone className="h-5 w-5" />
                        WhatsApp ile Ara
                    </Button>
                </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
